import { BookAppointmentProvider } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import { NotFound } from '@/pages/_exports';
import PlacePageV2 from '../../../features/PlacePages/PlacePage';
import ProfilePage from '../../../features/ProfilePages/ProfilePage';
import usePlaceData from './index.hooks';

export default function PlacePage() {
  const { place, loading, is404, isSistaminuten } = usePlaceData();

  if (is404) {
    return <NotFound />;
  }

  if (loading || !place?.id) {
    return null;
  }

  if (place.isExternalPlace) {
    return <ProfilePage place={place} />;
  }

  return (
    <BookAppointmentProvider place={place}>
      <PlacePageV2 place={place} isSistaminuten={isSistaminuten} />
    </BookAppointmentProvider>
  );
}
